import React from "react";
import Textfit from "react-textfit";

import s from "./RankPanel.module.scss";

import RankPanelEasy from "../../../assets/images/rank_panel_easy.png";
import RankPanelNormal from "../../../assets/images/rank_panel_normal.png";
import RankPanelHard from "../../../assets/images/rank_panel_hard.png";
import RankPanelOni from "../../../assets/images/rank_panel_oni.png";
import RankPanelUra from "../../../assets/images/rank_panel_ura.png";

const RankPanel = ({ currentPlayer, userData }) => {
    let profileDataKey;
    let playerScoreKey;

    if (currentPlayer === 1) {
        profileDataKey = "profile_p1";
        playerScoreKey = "record_enso_p1";
    } else {
        profileDataKey = "profile_p2";
        playerScoreKey = "record_enso_p2";
    }

    const difficulty = userData[profileDataKey].rankPanelDifficulty;
    const scores = userData[playerScoreKey];

    let scoreRanks = [0, 0, 0, 0, 0, 0, 0];
    let crowns = [0, 0, 0];

    if (scores && scores.length > 0) {
        scores.map((score) => {
            if (difficulty === 5) {
                if (score.difficulty === 4 || score.difficulty === 5) {
                    let { scorerank, crown } = score;

                    if (scorerank) {
                        scoreRanks[scorerank - 1]++;
                    }

                    if (crown) {
                        crowns[crown - 1]++;
                    }
                }
            } else {
                if (score.difficulty === difficulty) {
                    let { scorerank, crown } = score;

                    if (scorerank) {
                        scoreRanks[scorerank - 1]++;
                    }

                    if (crown) {
                        crowns[crown - 1]++;
                    }
                }
            }
            return true;
        });
    }

    const getRankPanelBg = (difficulty) => {
        switch (difficulty) {
            case 1:
                return RankPanelEasy;
            case 2:
                return RankPanelNormal;
            case 3:
                return RankPanelHard;
            case 4:
                return RankPanelOni;
            case 5:
                return RankPanelUra;
            default:
                return RankPanelUra;
        }
    };

    const RankPanelText = ({ text }) => {
        let maxSize = 16;

        return (
            <div className={s.outlinedText}>
                <Textfit
                    mode="single"
                    forceSingleModeWidth={false}
                    max={maxSize}
                    className={s.text}
                >
                    {text}
                </Textfit>
                <Textfit
                    mode="single"
                    forceSingleModeWidth={false}
                    max={maxSize}
                    className={s.base}
                >
                    {text}
                </Textfit>
            </div>
        );
    };

    return (
        <div
            style={{
                position: "relative",
                pointerEvents: "none",
            }}
        >
            <img src={getRankPanelBg(difficulty)} alt="rank_panel_bg" />
            <div className={s.rankPanelRanks}>
                {scoreRanks.map((scoreRank, index) => (
                    <RankPanelText key={`rank_${index}`} text={scoreRank} />
                ))}
            </div>

            <div className={s.rankPanelCrowns}>
                {crowns.map((crown, index) => (
                    <RankPanelText key={`crown_${index}`} text={crown} />
                ))}
            </div>
        </div>
    );
};

export default RankPanel;
